import {
  Box,
  Heading,
  Text,
  Grid,
  GridItem,
  Center,
  Button,
  Flex
} from '@chakra-ui/react';
import Image from 'next/legacy/image';
import Link from 'next/link';
import { LayoutContainer } from '@components/common';

export function CaseStudies(): JSX.Element {
  return (
    <LayoutContainer verticalPadding="sm">
      <Box pos="relative">
        <Center
          flexDir="column"
          pos="relative"
          zIndex={1}
          px={{ base: 6, lg: 8 }}
          textAlign="center"
        >
          <Heading as="h3" size="h3" mb={4}>
            Case Studies
          </Heading>

          <Text
            textStyle="paragraph-md"
            flex={1}
            maxW="474px"
            textAlign="center"
          >
            Learn how our customers have saved valuable time and resources by
            implementing Clerk into their product.
          </Text>
        </Center>
      </Box>

      <Grid
        templateAreas={{
          base: `"card1 card1 card1 card1"
          "card2 card2 card2 card2"`,
          lg: `"card1 card1 card2 card2"
                  "card1 card1 card2 card2"`,
          '2xl': `"card1 card1 card1 card1"
                  "card2 card2 card2 card2"`
        }}
        gap={6}
        color="blackAlpha.700"
        fontWeight="bold"
        mt={10}
      >
        <GridItem
          zIndex={1}
          pl="2"
          bg="white"
          shadow="md"
          rounded="xl"
          p={16}
          minH="312px"
          area={'card1'}
        >
          <Image
            src="/images/logos/trading-experts.svg"
            height="60"
            width="60"
            alt="Trading Experts"
          />
          <Flex flexDir="column" alignItems={{ base: 'center', lg: 'normal' }}>
            <Text textStyle={'md-normal'} my={4}>
              "I was super impressed. I thought I was just going to build a very
              basic email/password flow using something open source — knowing
              that I'd have to deal with issues my customers face down the line.
              With Clerk, I was able to give my users passwordless auth,
              seamless UIs, and a complete user profile in much less time than
              it would have taken to go the open source route. The free MFA was
              just icing, and some of our users have opted-in to it."
            </Text>
            <Text alignSelf={'flex-end'}>
              - Ben Zamani, Founder of Trading Experts
            </Text>
            <Link legacyBehavior href="/blog/trading-experts" passHref>
              <Button
                as="a"
                variant="white"
                w="200px"
                border="1px solid #E4E9F2"
                mt={8}
              >
                Read Story
              </Button>
            </Link>
          </Flex>
        </GridItem>
        <GridItem
          zIndex={1}
          pl="2"
          bg="white"
          shadow="md"
          rounded="xl"
          p={16}
          minH="312px"
          area={'card2'}
        >
          <Box ml={-3}>
            <Image
              src="/images/logos/opusflow.png"
              height="40"
              width="72"
              alt=""
            />
          </Box>
          <Flex flexDir="column" alignItems={{ base: 'center', lg: 'normal' }}>
            <Text textStyle={'md-normal'} my={4}>
              "We were blown away by the user-friendly authentication system
              that Clerk.com provides, allowing our SaaS to easily integrate
              with multiple teams of different skill levels. Not only did it
              offer MFA capabilities and organizations for a more efficient
              team, but its seamless integration into our tech stack resulted in
              an unbelievably productive experience! As CTO of OpusFlow, I'm
              extremely pleased with the 'just work' concept delivered via
              Clerk."
            </Text>
            <Text alignSelf={'flex-end'}>- Joey Teunissen, CTO OpusFlow</Text>
            <Link legacyBehavior href="/blog/opusflow" passHref>
              <Button
                as="a"
                variant="white"
                w="200px"
                border="1px solid #E4E9F2"
                mt={8}
              >
                Read Story
              </Button>
            </Link>
          </Flex>
        </GridItem>
      </Grid>
    </LayoutContainer>
  );
}
